import React, { useEffect, useState } from 'react'
import { Container } from './styled'
import { Empty, Modal } from 'antd'
import { HeaderTable } from '../../../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../../../Components/CustomUi/table/rowItem'
import { TitleH2 } from '../../../../../../../../Components/CustomUi/titleH2'
import { Inline } from '../../../../../../../../Components/CustomUi/inline'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faPlusMinus, faXmark } from '@fortawesome/free-solid-svg-icons'
import Tabs from '../../../../../../../../Components/Tabs'
import Carregando from '../../../../../../../../Components/CustomUi/loading'

type SoilInfo = {
  tipo: 'Altas' | 'Moderadas'
  elemento: string
  valor: number
  maximo: number
  ponto: number
  profundidade: string
}

interface Props {
  texto: string
  abrir: boolean
  setAbrir: React.Dispatch<React.SetStateAction<boolean>>
}

export const VisualizarInconsistencia: React.FC<Props> = ({ texto, abrir, setAbrir }) => {
  const [dadosRelatorio, setDadosRelatorio] = useState([])
  const [tab_selecionado, setTab_selecionado] = useState<'Altas' | 'Moderadas'>('Altas')
  const [loading, setLoading] = useState<boolean>(false)

  function extrairDadosRelatorio(textoBruto) {
    const resultado: SoilInfo[] = []

    // 1. Limpa o HTML (br) e divide em linhas
    const linhas = textoBruto
      .split(/<br\s*\/?>/gi)
      .map((l) => l.trim())
      .filter((l) => l)

    let categoriaAtual: 'Altas' | 'Moderadas' = 'Altas' // Valor padrão inicial

    // 2. Regex para capturar os grupos de informação
    // Ex: "Valor máximo de mg (3,01) ... (máximo de 2), para o ponto 2 em 00-20"
    const regex =
      /Valor máximo de (.+?) \(([\d,.]+)\).*?\(máximo de ([\d,.]+)\).*?para o ponto (\d+) em (.+)/i

    linhas.forEach((linha) => {
      // Detecta mudança de categoria
      if (linha.includes('Altas:')) {
        categoriaAtual = 'Altas'
        return
      }
      if (linha.includes('Moderadas:')) {
        categoriaAtual = 'Moderadas'
        return
      }

      const match = linha.match(regex)

      if (match) {
        // 3. Formata os dados capturados
        resultado.push({
          tipo: categoriaAtual,
          elemento: match[1].trim(), // ex: "mg", "ca", "ca_ctc"
          valor: parseFloat(match[2].replace(',', '.')), // Converte "3,01" para 3.01
          maximo: parseFloat(match[3].replace(',', '.')), // Converte maximo
          ponto: parseInt(match[4]), // Ponto
          profundidade: match[5].trim(), // Profundidade "00-20"
        })
      }
    })
    setTimeout(() => {
      setLoading(false)
    }, 800)
    setDadosRelatorio(resultado)
  }
  useEffect(() => {
    setLoading(true)
    extrairDadosRelatorio(texto)

    if (abrir === false) {
      setTab_selecionado('Altas')
    }

  }, [abrir])

  return (
    <Modal
      open={abrir}
      onCancel={() => setAbrir(false)}
      width={'600px'}
      destroyOnClose
      footer={false}
      zIndex={9999}
    >
      <Container>
        <Inline justifyContent='space-between'>
          <TitleH2>Resultado com inconsistência</TitleH2>
        </Inline>
        <Tabs
          tabs={[
            { icone: faArrowUp, descricao: 'Altas' },
            { icone: faPlusMinus, descricao: 'Moderadas' },
          ]}
          selecionado={tab_selecionado}
          onChange={setTab_selecionado}
          trackWidth={270}
        />
        <HeaderTable
          itens={[
            { valor: 'Elemento', width: '100px' },
            { valor: 'Profundidade', width: '120px' },
            { valor: 'Máximo', width: '100px' },
            { valor: 'Valor', width: '100px' },
            { valor: 'Ponto', width: '100px' },
          ]}
        />

        <BodyTable
          style={{
            height: '300px',
            position: 'relative',
            overflowX: 'hidden',
            overflowY: 'scroll',
            marginTop: -10,
          }}
        >
          <Render condition={loading === false}>
            {(dadosRelatorio ?? [])
              .filter((item) => item?.tipo === tab_selecionado)
              .map(({ elemento, valor, maximo, ponto, profundidade }, index) => {
                return (
                  <RowTable
                    key={index}
                    onDoubleClick={() => { }}

                  >
                    <RowItem fontSize={13} width={'99px'}>
                      {elemento}
                    </RowItem>
                    <RowItem fontSize={12} width={'120px'}>
                      {profundidade}
                    </RowItem>

                    <RowItem fontSize={12} width={'100px'}>
                      {maximo}
                    </RowItem>

                    <RowItem fontSize={12} width={'100px'}>
                      {valor}
                    </RowItem>
                    <RowItem fontSize={12} width={'125px'}>
                      {ponto}
                    </RowItem>
                  </RowTable>
                )
              })}
          </Render>

          <Render condition={loading}>
            <Carregando
              animation
              legenda='Carregando...'
              size='small'
              justifyContent='center'
              height={300}
            />
          </Render>

          <Render condition={dadosRelatorio.filter((item) => item?.tipo === tab_selecionado).length <= 0}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          </Render>
        </BodyTable>
      </Container>
    </Modal>
  )
}
